import { Link } from "react-router-dom";

const features = [
  {
    title: "対話で整理",
    description: "相談や壁打ちを通じて、考えを自然に整理できます。",
  },
  {
    title: "毎日の伴走",
    description: "仕事や生活のリズムに合わせて、必要なタイミングで寄り添います。",
  },
  {
    title: "すぐに開始",
    description: "ブラウザからそのまま起動して、すぐに使い始められます。",
  },
];

export default function LandingPage() {
  return (
    <main className="min-h-screen overflow-hidden bg-[radial-gradient(circle_at_top,#FFF6EE_0%,#FDF8F5_42%,#F6ECE4_100%)] px-6 py-8 text-[#4A3E39] antialiased">
      <div className="mx-auto flex w-full max-w-5xl flex-col gap-8">
        <header className="flex items-center justify-between gap-4 rounded-full border border-[#EADBC8] bg-white/75 px-5 py-3 shadow-[0_10px_24px_rgba(166,124,82,0.10)] backdrop-blur-sm">
          <div>
            <p className="text-[11px] font-bold tracking-[0.18em] text-[#A67C52]">PERSONAL CONCIERGE</p>
            <p className="text-lg font-black tracking-tight text-[#7C5A4E]">WizMate</p>
          </div>
          <div className="flex items-center gap-3 text-sm">
            <Link to="/privacy" className="font-bold text-[#7B6861] underline-offset-4 hover:underline">
              プライバシーポリシー
            </Link>
            <Link
              to="/splash"
              className="rounded-full bg-[#7C5A4E] px-4 py-2 font-bold text-white transition hover:bg-[#6D4D42]"
            >
              アプリを開く
            </Link>
          </div>
        </header>

        <section className="relative overflow-hidden rounded-[2.4rem] border border-[#EADBC8] bg-white/78 px-7 py-10 shadow-[0_18px_40px_rgba(166,124,82,0.14)] backdrop-blur-sm md:px-10 md:py-12">
          <div className="pointer-events-none absolute -right-16 top-[-3rem] h-52 w-52 rounded-full bg-[#F4DED0] blur-3xl" />
          <div className="pointer-events-none absolute -left-10 bottom-[-4rem] h-48 w-48 rounded-full bg-[#F8EBDD] blur-3xl" />

          <div className="relative grid gap-8 md:grid-cols-[1.2fr_0.8fr] md:items-center">
            <div>
              <p className="text-sm font-bold tracking-[0.16em] text-[#A67C52]">WEB APP</p>
              <h1 className="mt-3 text-4xl font-black leading-tight tracking-tight text-[#5D4037] md:text-5xl">
                あなたの毎日に、
                <br />
                専属コンシェルジュを。
              </h1>
              <p className="mt-5 max-w-2xl text-sm leading-7 text-[#6B5851] md:text-base">
                WizMate は、相談、整理、振り返りをやさしく支える対話型アプリです。外出先でもデスクでも、必要なときにすぐ立ち上げて使えます。
              </p>

              <div className="mt-7 flex flex-wrap items-center gap-3">
                <Link
                  to="/splash"
                  className="rounded-2xl bg-[#7C5A4E] px-5 py-3 text-sm font-bold text-white transition hover:bg-[#6D4D42]"
                >
                  今すぐはじめる
                </Link>
                <Link
                  to="/privacy"
                  className="rounded-2xl border border-[#D9C4B3] bg-[#FFF9F4] px-5 py-3 text-sm font-bold text-[#7C5A4E] transition hover:bg-[#FCF1E8]"
                >
                  プライバシーポリシー
                </Link>
              </div>
            </div>

            <div className="mx-auto w-full max-w-sm">
              <div className="rounded-[2rem] border border-white/70 bg-[#FFF7F1] p-5 shadow-[0_16px_36px_rgba(166,124,82,0.12)]">
                <div className="mx-auto h-52 w-52 overflow-hidden rounded-full border-[6px] border-white bg-white shadow-[0_12px_28px_rgba(166,124,82,0.18)]">
                  <img src="/img/logo.jpg" alt="WizMate Logo" className="h-full w-full object-cover object-center" />
                </div>
                <div className="mt-5 rounded-[1.4rem] bg-white px-4 py-4">
                  <p className="text-xs font-bold tracking-[0.14em] text-[#A67C52]">READY TO START</p>
                  <p className="mt-2 text-base font-bold text-[#5D4D46]">ブラウザですぐに起動できます</p>
                  <p className="mt-2 text-sm leading-6 text-[#7B6861]">
                    初回利用の方も、既にご利用中の方も、アプリ起動画面からそのままお使いいただけます。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="grid gap-4 md:grid-cols-3">
          {features.map((feature) => (
            <article
              key={feature.title}
              className="rounded-[1.8rem] border border-[#EADBC8] bg-white/76 px-5 py-5 shadow-[0_12px_30px_rgba(166,124,82,0.10)] backdrop-blur-sm"
            >
              <p className="text-base font-black text-[#5D4D46]">{feature.title}</p>
              <p className="mt-2 text-sm leading-7 text-[#7B6861]">{feature.description}</p>
            </article>
          ))}
        </section>
      </div>
    </main>
  );
}
